import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Logger } from '@crt/sui';
import { CookieService } from 'ngx-cookie-service';

const CROSS_DOMAIN_RETURN_TO = 'crossDomainReturnTo';

/**
 * TODO (lovell): This is a temporary workaround till we get the login service to support
 * dynamic callbacks so that we skip the CRT UI when logging in from CopaIdentity.
 *
 * App level guard to return the CopaIdentity user back to where they came from.
 * This is only for non username+password logins.
 *
 * When a user logs in to CopaIdentity (*.login.copado.com) they are taken to the CRT login service
 * which handles the login process and creates the `copa-token` cookie. But since CRT login service
 * callbacks are hardcoded they return to the CRT UI. Jukka says we can't update the login service
 * callbacks to be dynamic without breaking everything.
 *
 * Hence this cookie to take the user back to the original URL.
 */
function isAllowedHostname(hostname: string): boolean {
  return hostname === 'copado.com' || hostname.endsWith('.copado.com');
}

export const crossDomainReturnToGuard: CanActivateFn = () => {
  const cookieService = inject(CookieService);

  const returnTo = cookieService.get(CROSS_DOMAIN_RETURN_TO);

  if (returnTo) {
    try {
      const url = new URL(returnTo);
      if (isAllowedHostname(url.hostname)) {
        cookieService.delete(CROSS_DOMAIN_RETURN_TO, '/', 'copado.com', true);
        window.location.href = url.href;
        return false;
      }
    } catch {
      Logger.error('[crossDomainReturnToGuard] Invalid URL: ', { data: returnTo });
    }
  }

  return true;
};
